goog.provide('el8.util.amplitude.prescriptionFormHelpers');

goog.require('el8.util.amplitude.helpers');
goog.require('el8.util.consts');

/**
 * Log that a start prescription form event occurred.
 *
 * @param {string} source - identification of where the form was launched from
 * @param {string} formType - the type of prescription form launched (prescription, otc, controlled, etc.)
 */
el8.util.amplitude.logStartPrescription = function(source, formType) {
    var ampData = {
        'source': el8.util.consts.TAXONOMY_REF_BOARD_SECTION_HEADER_ID_NAME_MAP[source] || source,
        'form type': el8.util.consts.TAXONOMY_PRESCRIPTION_FORM_TYPE_NAME_MAP[formType] || formType,
        'version':  '3.0 Unified Rx form'
    };
    el8.util.amplitude.logEvent('start prescription form', ampData);
};

/**
 * Log that a complete prescription form event occurred.
 *
 * @param {string} completionMethod - method of prescription form completion (ePrescribe Only, Print & Close, etc.)
 * @param {number} numberOfMeds
 */
el8.util.amplitude.logCompletePrescription = function(completionMethod, numberOfMeds) {
    var ampData = {
        'action': completionMethod,
        'number of meds': numberOfMeds
    };
    el8.util.amplitude.logEvent('complete prescription form', ampData);
};


/**
 * Log that a start change rx request event occurred.
 *
 * @param {string} button - button that the user clicked
 * @param {string} changeRequestType - type of the change request
 * @param {boolean} isControlled - if the change request is for a controlled substance
 */
el8.util.amplitude.logStartChangeRxResponse = function(button, changeRequestType, isControlled) {
    var ampData = {
        'changeRx type': changeRequestType,
        'button selection': button,
        'is controlled': isControlled ? 'yes' : 'no'
    };
    el8.util.amplitude.logEvent('start changeRx response', ampData);
};

/**
 * Log that a start cancel rx request event occurred.
 *
 * @param {string} source - identification of where the form was launched from
 * @param {boolean} isControlled - identification of where the form was launched from
 */
el8.util.amplitude.logStartCancelRxRequest = function(source, isControlled) {
    var ampData = {
        'source': el8.util.consts.TAXONOMY_REF_BOARD_SECTION_HEADER_ID_NAME_MAP[source] || source,
        'is controlled': isControlled ? 'yes' : 'no'
    };
    el8.util.amplitude.logEvent('start cancelRx request', ampData);
};

/**
 * @param {boolean} isControlled
 */
el8.util.amplitude.logStartRefileRenewalRequest = function(buttonName, isControlled) {
    var ampData = {
        'button selection': buttonName,
        'is controlled': isControlled ? 'yes' : 'no'
    };
    el8.util.amplitude.logEvent('Start refile RenewalRx request', ampData);
};

/**
 * @param {string} buttonName
 */
el8.util.amplitude.logCompleteRefileRenewalRequest = function(buttonName, isControlled) {
    var ampData = {
        'button selection': buttonName,
        'is controlled': isControlled
    };
    el8.util.amplitude.logEvent('Complete refile RenewalRx request', ampData);
};

/**
 * @param {string} buttonName
 * @param {boolean} isControlled
 */
el8.util.amplitude.startRenewalRxResponse = function(buttonName, isControlled) {
    var ampData = {
        'button selection': buttonName,
        'is controlled': isControlled ? 'yes' : 'no'
    };
    el8.util.amplitude.logEvent('Start RenewalRx response', ampData);
};

/**
 * @param {string} buttonName
 * @param {boolean} isControlled
 */
el8.util.amplitude.completeRenewalRxResponse = function(buttonName, isControlled) {
    var ampData = {
        'button selection': buttonName,
        'is controlled': isControlled
    };
    el8.util.amplitude.logEvent('Complete RenewalRx response', ampData);
};

/**
 * @param {string} buttonName
 * @param {bolean} numberOfRefillsChanged
 * @param {boolean} hasNote
 */
el8.util.amplitude.startCompleteChangeNumberRefillRenewalRxResponse = function(buttonName, numberOfRefillsChanged, hasNote) {
    var ampData = {
        'button selection': buttonName,
        'Changes to refill number': numberOfRefillsChanged ? 'Change' : 'No change',
        'Adds refills note': hasNote ? 'Note' : 'No note'
    };
    el8.util.amplitude.logEvent('Start Complete Change Refill RenewalRx response', ampData);
};

/**
 * @param {string} buttonName
 * @param {string} missingDenialMessage
 */
el8.util.amplitude.startCompleteDenyRenewalRxResponse = function(buttonName, missingDenialMessage) {
    var ampData = {
        'button selection': buttonName,
        'Missing denial message': missingDenialMessage
    };
    el8.util.amplitude.logEvent('Start Complete Deny RenewalRx response', ampData);
};
